<template>
	<div>
		
		<b-modal ref="boxplotDetail" size="xl" hide-footer :title="modalDetailTitle" >
			<div class='row p-3' v-if="formatted_data">
			<p class="text-center">	color by {{colorType}} : <span v-for="(col,name) in colorMatching" class="mr-3"><div style="height:15px;width:15px;display:inline-flex" :style="{'background-color':col}"></div> {{name}}<span v-if="colorType=='age'"> months</span></span></p>
				<table class="table table-sm" v-if="comparison">
					<thead>
						<tr>
							<th>Color</th>
							<th>{{comparison}}</th>
							<th>nb values</th>
							<th>min</th>
							<th>outsiders</th>
							<th>Q1 - 1.5*IQR</th>
							<th>Q1</th>
							<th>median</th>
							<th>Q3</th>
							<th>Q3 + 1.5*IQR</th>
							<th>outsiders</th>
							<th>max</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="cat in formatted_data.categories">
							<td><div class="mx-2" style="width:15px;height:15px;" :style="{'background-color':getStrokeColor(cat,'modal')}"></div></td>
							<td>{{cat.cat_idx}}</td>
							<td>{{cat.data.length}}</td>
							<td>{{cat.min}}</td>
							<td>{{cat.outsiders.min.data.join(', ')}}</td>
							<td>{{cat.q1_1}}</td>
							<td>{{cat.q1}}</td>
							<td>{{cat.median}}</td>
							<td>{{cat.q3}}</td>
							<td>{{cat.q3_3}}</td>
							<td>{{cat.outsiders.max.data.join(', ')}}</td>
							<td>{{cat.max}}</td>
						</tr>
					</tbody>
				</table>
				<table class="table table-sm" v-else>
					<thead>
						<tr>
							<th>Color</th>
							<th>Name</th>
							<th>NB</th>
							<th>Values</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="cat in formatted_data.categories">
							<td><div class="mx-2" style="width:15px;height:15px;" :style="{'background-color':getStrokeColor(cat,'modal')}"></div></td>
							<td>{{cat.cat_idx}}</td>
							<td>{{cat.data.length}} replicate<span v-if="cat.data.length>1">s</span></td>
							<td>{{cat.onlydata.join(", ")}}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</b-modal>
		
		<p class="text-center" style="margin-bottom:0">{{dataset.name}} <span @click="openDetails(dataset)" class="pointer" v-b-tooltip.hover title="Graph data details"><v-icon style="height:14px" class="align-middle" name="plus-square"></v-icon></span><br><small>{{dataset.description}}</small></p>		
		<div :id="container_id" ref='geneplot' class="relative">
			<svg></svg>
		</div>
	</div>
</template>

<script>	
import {HTTP} from '@/router/http';
import {siteTitle} from '@/app_config';
import * as d3 from "d3"
import d3Tip from "d3-tip";
import { mapGetters } from 'vuex';
export default {
	name: 'GenePlot',
	props:['gene','dataset','comparison','colorType','colorMatching'],
	data () {
		return {
			formatted_data:null,
		}
	},
	computed:{
		...mapGetters({
			currentUser: 'currentUser',
			colors:'colors',
		}),
		data(){
			let _this = this;
			if (_this.gene && _this.dataset){ return _this.gene.datasets[_this.dataset.name].data; }
		},
		headers(){
			let _this = this;
			if (_this.gene && _this.dataset){ return _this.gene.datasets[_this.dataset.name].headers; }
		},
		geneName(){
			let _this = this;
			if (_this.gene){ return _this.gene.gene_name; }
		},
		geneGroups(){
			let _this = this;
			if (_this.gene){ return _this.gene.groupByTypes; }
		},
		ensemblID(){
			let _this = this;
			if (_this.gene){ return _this.gene.ensemblID; }
		},
		container_id(){
			return 'geneplot_'+this.ensemblID+"_"+this.dataset.name;
		},
		modalDetailTitle(){
			let title = this.geneName + " - " + this.dataset.name + " : compare by " ;
			title += (this.comparison) ? this.comparison : ' replicates';
			// title += ' color by ' + this.colorType;
			return title;
		}
	},
	watch: {
		gene: {
				handler () {
					let _this = this
					console.info("watch gene");
					_this.render();
				},
				deep: true
			},
		comparison: {
			handler () {
				// console.info("watch group comparison");
				let _this = this;
				_this.render();
			}
		},
		colorType: {
			handler () {
				console.info("watch color comparison");
				let _this = this;
				_this.render();
			}
		}
	},
	methods:{
	  comparisonDisplayed: function (comparison) {
			if (!comparison){ return; }
			let tmp_display = comparison.replace("_"," ");    
	  	let display = tmp_display[0].toUpperCase() + tmp_display.substr(1);
			return display;
		},
		round(d,nb){
			if (!nb) nb = 2;
			let mult = 10*nb;
			return Math.round(d * mult) / mult;
		},
		quartile(data, q) {
			let _this = this;
		  var pos = ((data.length) - 1) * q;
		  var base = Math.floor(pos);
		  var rest = pos - base;
		  if ((data[base+1]!==undefined) ) { return _this.round(data[base] + rest * (data[base+1] - data[base])); }
			else { return data[base]; }
		},
		
		formatData(){
			let _this = this;

			let data = [];
			let compare = _.find(_this.dataset.variables,function(v){return v.name==_this.comparison;});
			let categories = {};
			let inc = 1;

			let min = 0, max = 0, val;

			_.forEach(_this.headers,function(h,hidx){
				
				if (hidx){

					val = _this.round(_this.data[hidx]);
					if (min>+_this.data[hidx]) min = +_this.data[hidx];
					if (max<+_this.data[hidx]) max = +_this.data[hidx];
					let d = {val:val,head:h};


					if (_this.dataset.matrix[h]){						
						_.forEach(_this.dataset.variables,function(v,vidx){d[v.name]=_this.dataset.matrix[h][v.idx]; })
						d.title = _this.dataset.matrix[h][_this.dataset.title_idx].trim();
						d.trim_title = d.title.replace(/rep.$/, '').trim().replace(/\s/gm,'_');

						
						let cat_idx = d.trim_title;
						if (_this.comparison){
							// cat_idx = (d[_this.comparison]) ? d[_this.comparison] : 'NA';
							cat_idx = (d[_this.comparison]) ? d[_this.comparison].replace(/\s/gm,'_') : 'NA';
						}
						// else{
						// 	d.month = +d.age.split(" ")[0];
						// 	cat_idx = d['trim_title'] ;
						// }
						d.cat_idx = cat_idx;

						if (!categories[cat_idx]){
							categories[cat_idx] = {idx:inc,Sex:d.Sex,cat:d[_this.comparison],cat_idx:cat_idx,data:[],min:d.val,max:d.val,onlydata:[]};
							// categories[cat_idx].nbQ = (_this.comparison=='nbQ') ? +cat_idx : _this.getPattern(categories[cat_idx].cat_idx,'nbQ');
							categories[cat_idx].nbQ = +d.nbQ;
							categories[cat_idx].age = d.age;
							inc++;
						}
						d.nbQ = +d.nbQ;
						// d.nbQ = _this.getPattern(d.trim_title,'nbQ');
						d.month = +d.age.split(" ")[0];
						// d.month = _this.getPattern(d.trim_title,'month');
						d.color = categories[cat_idx].color;
						categories[cat_idx].data.push(d);
						categories[cat_idx].onlydata.push(d.val);
						if (categories[cat_idx].min>d.val) categories[cat_idx].min = d.val;
						if (categories[cat_idx].max<d.val) categories[cat_idx].max = d.val;
					}

				}
			})
			_.forEach(categories,function(cat){
				let outsite = {min:false,max:false};
				cat.onlydata = _.sortBy(cat.onlydata);
				cat.q1 = _this.quartile(cat.onlydata,0.25);
				cat.median = _this.quartile(cat.onlydata,0.5);
				cat.q3 = _this.quartile(cat.onlydata,0.75);
				cat.iqr = _this.round(cat.q3-cat.q1); 
				cat.q1_1 = _this.round(cat.q1-1.5*cat.iqr);
				cat.q1_1_idx = _.findIndex(cat.onlydata,function(d){return d>cat.q1_1;});
				cat.q3_3 = _this.round(cat.q3+1.5*cat.iqr);
				cat.q3_3_idx = _.findLastIndex(cat.onlydata,function(d){return d<cat.q3_3;});
				cat.outsiders = {min:{status:false,data:[],idx:null},max:{status:false,data:[],idx:null}};
				cat.month = +cat.age.split(' ')[0];
				
				for (var i=0;i<cat.onlydata.length*0.25;i++){
					if (cat.onlydata[i]<cat.q1_1){
						cat.outsiders.min.idx = i;
						cat.outsiders.min.status = true;
						cat.outsiders.min.data.push(cat.onlydata[i]);						
					} 
				}
				for (var j=cat.onlydata.length;j>Math.round(cat.onlydata.length*0.75);j--){
					if (cat.onlydata[j]>cat.q3_3){
						cat.outsiders.max.idx = j;
						cat.outsiders.max.status = true;
						cat.outsiders.max.data.push(cat.onlydata[j]);
					}
				}
				if (!cat.outsiders.min.status) cat.bar_min = cat.min;
				else cat.bar_min = cat.onlydata[cat.q1_1_idx];
				if (!cat.outsiders.max.status) cat.bar_max = cat.max;
				else cat.bar_max = cat.q3_3;

			})
			let new_categories = _.sortBy(_.values(categories),['nbQ','month','cat_idx']);
			let catnames = _.map(new_categories,'cat_idx');

			return {min:min,max:max,categories:new_categories,category_names:catnames,catnb:catnames.length};

		},
		getPattern(name,cas){
			var regex = (cas=='nbQ') ? /Q(\d+)/ : /(\d+) month/;
			var q = regex.exec(name);
			if (q){return +q[1]; }
			else return (cas=='nbQ') ? 7 : null;
		},

		openDetails(d){
			let _this = this;
			_this.$refs.boxplotDetail.show()
			
		},
		getStrokeColor(d,from){
			let _this = this;
			let variable = d[_this.colorType];
			if (_this.comparison=='age' || _this.comparison=='Sex')return 'black';
			if (_this.colorType=='age' && d.age){ variable = d.age.split(" ")[0]; }
			return  (_this.colorMatching[variable]) ? _this.colorMatching[variable] : 'black';
		},
		render(){
			var _this = this;
			var totalWidth = _this.$refs['geneplot'].clientWidth*.9;

			var totalheight = 400;
			var margin = {top: 40, right: 60,bottom:50, left: 100},
				width = totalWidth - margin.left - margin.right,
				height = totalheight - margin.top - margin.bottom;
				margin.bottom = (_this.comparison) ? 130 : 50;

			d3.select("#"+_this.container_id + " svg").remove();
			var svg = d3.select("#"+_this.container_id).append('svg').attr("width", width + margin.left + margin.right) .attr("height", height + margin.top + margin.bottom).append('g').attr('class','main_group') .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
			var data = _this.formatData();
			_this.formatted_data = data;

			var y = d3.scaleLinear().range([height, 0]).domain([data.min,data.max]);		
			if (_this.comparison) {
				var x = d3.scalePoint() .domain(data.category_names) .rangeRound([0, width]) .padding([0.5]);		
			}
			else{
				var x = d3.scalePoint() .domain(data.category_names) .rangeRound([0, width]) .padding([0.5]);		
			}

			var tip = d3Tip().attr('class', 'd3-tip test-tip').style('background-color','rgba(255,255,255,0.85)').style('border','1px solid #999').style('padding','5px').style('z-index',100000).style('border-radius','3px').direction('e').offset([0,5])
				.html(function(d) {
					var content = "<span style='margin-left: 5px;font-size:10px'><b>" + d.title + "</b></span><br>";
					content +=`
					<table style="margin-top: 2.5px;font-size:10px">
					<tr><td>Value: </td><td>` + d.val + `</td></tr>
					<tr><td>Sex: </td><td>` + d.Sex + `</td></tr>
					<tr><td>Age: </td><td>` + d.age + `</td></tr>
					<tr><td>NbQ: </td><td>` + d.nbQ + `</td></tr>
					<tr><td>Genotype: </td><td>` + d.genotype + `</td></tr>
					<tr><td>Housing condition: </td><td>` + d.housing_condition + `</td></tr>
					</table>
					`;				
					return content;
				});
			svg.call(tip);

			var datagroup = svg.append('g').attr('class','group_data');

			var pointSelection = datagroup.selectAll('.point_group').data(data.categories)

			var pointEnterGroup = pointSelection.enter().append('g').attr('transform',function(d){return 'translate('+x(d.cat_idx)+',0)'}).attr('class','boxplot')
			
			for (var i=2;i<data.max;i++){
				datagroup.append('line').attr('x1',0).attr('x2',width).attr('y1',y(i)).attr('y2',y(i)).attr('stroke','lightgrey').attr('stroke-width',.3);
			}
			if (_this.comparison){
				// pointEnterGroup
				pointEnterGroup.append('rect') .attr('height',function(d,i){return y(d.q1)-y(d.q3);}) .attr('width',30).attr('x',-15).attr('y',function(d){return y(d.q3)}).attr('fill','none')
				.attr('stroke',function(d){return _this.getStrokeColor(d);}).attr('stroke-width',1.5);
				pointEnterGroup.append('line').attr('y1',function(d){return y(d.bar_min);}).attr('y2',function(d){return y(d.q1);}).attr('stroke','black')
				pointEnterGroup.append('line').attr('y1',function(d){return y(d.bar_max);}).attr('y2',function(d){return y(d.q3);}).attr('stroke','black')
				pointEnterGroup.append('line').attr('x1',-15).attr('x2',15).attr('y1',function(d){return y(d.median);}).attr('y2',function(d){return y(d.median);}).attr('stroke',function(d){return _this.getStrokeColor(d);})
				pointEnterGroup.append('line').attr('x1',-5).attr('x2',5).attr('y1',function(d){return y(d.bar_min);}).attr('y2',function(d){return y(d.bar_min);}).attr('stroke','black')
				pointEnterGroup.append('line').attr('x1',-5).attr('x2',5).attr('y1',function(d){return y(d.bar_max);}).attr('y2',function(d){return y(d.bar_max);}).attr('stroke','black')
				pointEnterGroup.selectAll('.outsiders_min').data(function(d){return d.outsiders.min.data}).enter().append('circle').attr('r',2).attr('cy',function(d){return y(d);});
				pointEnterGroup.selectAll('.outsiders_max').data(function(d){return d.outsiders.max.data}).enter().append('circle').attr('r',2).attr('cy',function(d){return y(d);});

			}
			else{
				pointEnterGroup.selectAll('.points').data(function(d){return d.data;}).enter().append('circle') .attr('cy',function(d,i){return y(d.val);}) .attr('r',3).attr('fill',function(d){return _this.getStrokeColor(d);})
				.on('mouseover',function(d,i,n){tip.show(d,n[i])}).on('mouseout',function(d,i,n){tip.hide(d,n[i])})
			}

		  var x_axis = svg.append("g") .attr("transform", "translate(0," + height + ")") .call(d3.axisBottom(x))
			.selectAll("text") .style("text-anchor", "end") .attr("dx", "-.8em") .attr("dy", ".15em") .attr("transform", "rotate(-65)").text(function(d,i){return (_this.comparison) ? d.replace(/\_/gm,' ') : null});
		  var y_axis = svg.append("g") .call(d3.axisLeft(y)) .append("text") .attr("class", "label") .attr("transform", "rotate(-90)") .attr("y", 15) .style("text-anchor", "end") .text("FPKM");
			
			x_axis.append('text') .attr('class', 'axis-label') .attr('x', width / 2) .attr('y', 100) .text('x');
			y_axis.append('text') .attr('class', 'axis-label') .attr('x', -height / 2) .attr('y', -60) .attr('transform', `rotate(-90)`) .style('text-anchor', 'middle') .text('FPKM');
 		 
		 	svg.append("text") .attr("transform", "rotate(-90)") .attr("y", 0 - margin.left+45) .attr("x",0 - (height / 2)) .attr("dy", "1em") .style("text-anchor", "middle").style("font-size",'14px') .text("FPKM counts");
			svg.append("text") .attr("transform", "translate(" + (width-10) + " ," + (height + margin.top - 15) + ")").style("font-size",'14px') .text(_this.comparisonDisplayed(_this.comparison));

		}		

	},
	mounted() {
		this.render();
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.d3-tip {
		background-color: rgba(255,255,255,0.85);
		padding: 5px;
		border: 1px solid #999;
		border-radius: 3px;
		z-index: 100000;
	}
	.test-tip {
		background-color: rgba(255,255,255,0.85)!important;
		padding: 5px !important;
		border: 1px solid #999 !important;
		border-radius: 3px !important;
		z-index:100000 !important;
	}

h1, h2 {
	font-weight: normal;
}
a {
	color: #42b983;
}
</style>
